import React, { Fragment, useEffect, useRef, useState, useCallback } from 'react'
import { Link } from "react-router-dom"
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import { marNotificationsAction } from '../../redux/actions/notificationsActions';
import { useDispatch } from 'react-redux';
import DefaultAvatar from "../images/avatar.png"

dayjs.extend(relativeTime);

const NotificationsAlerts = ({ notificationData }) => {
    const dispatch = useDispatch()
    const [visible, setVisible] = useState(false)
    const timerRef = useRef(null)

    const clearTimer = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current)
        }
    }, [])

    const startTimer = useCallback(() => {
        timerRef.current = setTimeout(() => {
            setVisible(false)
        }, 50000)
    }, [])

    useEffect(() => {
        if (notificationData?.title) {
            setVisible(true)
            startTimer()
        }
        return () => clearTimer()
    }, [notificationData, startTimer, clearTimer])

    const handleClose = () => {
        clearTimer()
        setVisible(false)
    }

    const handleLink = (target) => {
        if (target === "PRODUCT") return `/products/single-product?id=${notificationData?.related_product_id}`;
        if (target === "ORDER") return `/orders/order-details?order_id=${notificationData?.related_order_id}`;
        if (target === "REPORT") return `/order-reports`;
        if (target === "USER") return `/dashboard/user-details?user_id=${notificationData?.related_user_id}`;
        return "/";
    }

    const handleDispatch = () => {
        dispatch(marNotificationsAction({ notification_id: notificationData.notification_id }))
    }

    const isInfo = notificationData?.type === "INFO";

    return (
        <Fragment>
            <div
                onMouseEnter={clearTimer}
                onMouseLeave={startTimer}
                className={`fixed top-4 right-4 z-[9999] w-[calc(100%-2rem)] sm:w-[420px] bg-white/95 backdrop-blur-sm p-5 shadow-[0_20px_50px_-12px_rgba(0,0,0,0.15)] rounded-2xl border border-zinc-100 transition-all duration-500 ease-out
                ${visible ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0 pointer-events-none"}
                `}
            >
                <div className="flex gap-4 relative">
                    {/* Close Button */}
                    <button
                        className="absolute top-0 right-0 w-6 h-6 flex items-center justify-center rounded-full bg-zinc-50 hover:bg-zinc-100 text-zinc-400 hover:text-zinc-600 transition-colors"
                        onClick={handleClose}
                    >
                        <i className="fa-solid fa-xmark text-xs"></i>
                    </button>

                    {/* Image/Avatar Section */}
                    <div className="flex-shrink-0 relative">
                        <div className="w-14 h-14 rounded-2xl overflow-hidden bg-zinc-50 border border-zinc-100 shadow-sm">
                            <img
                                src={notificationData?.image_url || DefaultAvatar}
                                alt=""
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* Status Icon Overlay */}
                        <div className={`absolute -bottom-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center text-xs border-2 border-white shadow-sm
                            ${isInfo ? "bg-sky-500" : "bg-rose-500"}
                        `}>
                            <i className={`fa-solid ${isInfo ? "fa-bell" : "fa-triangle-exclamation"} text-white text-[10px]`}></i>
                        </div>
                    </div>

                    {/* Content Section */}
                    <div className="flex-grow flex flex-col justify-between pt-0.5 pr-6">
                        <div>
                            <p className="text-sm font-medium text-zinc-700 leading-snug">
                                {notificationData?.message}
                            </p>
                            {notificationData?.created_by_name && (
                                <span className="inline-flex items-center gap-1.5 mt-1.5 px-2 py-0.5 rounded-full bg-sky-50 text-xs font-bold text-sky-700">
                                    <div className="w-1 h-1 bg-sky-500 rounded-full"></div>
                                    {notificationData?.created_by_name}
                                </span>
                            )}
                        </div>

                        <div className="flex items-center justify-between mt-4">
                            <span className="text-xs text-zinc-400 font-medium flex items-center gap-1">
                                <i className="fa-regular fa-clock text-[11px]"></i>
                                {dayjs(notificationData?.created_at).fromNow()}
                            </span>

                            <Link
                                to={handleLink(notificationData?.target)}
                                onClick={() => {
                                    handleDispatch();
                                    handleClose();
                                }}
                                className="text-sm font-bold text-sky-600 hover:text-sky-700 transition-colors flex items-center gap-1 group"
                            >
                                View
                                <i className="fa-solid fa-arrow-right text-xs group-hover:translate-x-0.5 transition-transform"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default NotificationsAlerts